// AuthUtils.js - Centralized authentication utilities
const AuthUtils = {
	/**
	 * Validates JWT token format and basic structure
	 * @param {string} token - JWT token to validate
	 * @returns {boolean} Whether the token is valid
	 */
	isValidJwtToken: (token) => {
		// Check if token is a non-empty string
		if (typeof token !== 'string' || token.trim() === '') {
			console.error('JWT token must be a non-empty string.');
			return false;
		}

		// Verify token has three parts separated by periods
		const parts = token.split('.');
		if (parts.length !== 3) {
			return false;
		}

		return true;
	},

	/**
	 * Checks if user is authenticated with valid token
	 * @param {Object} userData - User data object containing JWT token
	 * @returns {boolean} Authentication status
	 */
	isAuthenticated: (userData) => {
		return !!userData?.jwtToken && AuthUtils.isValidJwtToken(userData.jwtToken);
	},
};

export default AuthUtils;
